module.exports = __webpack_public_path__ + "static/media/cq_nascondi.7552ff78.svg";